import { Checkbox, ClipboardButton, TextInput, Typography } from '@neo4j-ndl/react';
import { isNotNullish } from '@nx/stdlib';

import { SingleLineCodeBlock } from '../../../shared/components';

export const TokenOutput = ({
  token,
  hasAcknowledged,
  acknowledge,
}: {
  token: string;
  hasAcknowledged?: boolean;
  acknowledge?: (hasAcknowledged: boolean) => void;
}) => {
  const proc = `USE system \nCALL fleetManagement.registerToken("${token}");`;
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col">
        <Typography variant="subheading-small">Step 1: Save your token credential.</Typography>
        <TextInput
          isFluid
          value={token}
          label="Token credential"
          htmlAttributes={{
            'aria-label': 'Token credential',
            readOnly: true,
          }}
          rightElement={
            <ClipboardButton
              textToCopy={token}
              htmlAttributes={{ 'aria-label': 'Copy to clipboard' }}
              tooltipProps={{
                isPortaled: false,
                type: 'simple',
              }}
            />
          }
        />
      </div>
      <div className="flex flex-col">
        <Typography variant="subheading-small">Step 2: Register your saved token to your deployment.</Typography>
        <ol className="mx-4 list-disc">
          <li>
            <Typography variant="body-medium">
              Connect to your self-managed Neo4j instance using any of the Neo4j clients as admin.
            </Typography>
          </li>
          <li>
            <Typography variant="body-medium">
              Switch to use <code className="bg-palette-neutral-bg-default px-1">system</code> database & run the Fleet
              management procedure to register the token.
            </Typography>
            <SingleLineCodeBlock code={proc} language="cypher" />
          </li>
        </ol>
      </div>
      {isNotNullish(hasAcknowledged) && isNotNullish(acknowledge) && (
        <div className="mt-2 flex flex-row items-center gap-1">
          <Checkbox
            label="I have registered token to my deployment."
            isChecked={hasAcknowledged}
            onChange={() => acknowledge(!hasAcknowledged)}
          />
        </div>
      )}
    </div>
  );
};
